export default {
  default: () => import("/opt/atlassian/pipelines/agent/build/layouts/default.vue"),
  domain: () => import("/opt/atlassian/pipelines/agent/build/layouts/domain.vue"),
  platform: () => import("/opt/atlassian/pipelines/agent/build/layouts/platform.vue")
}